import { Component } from '@angular/core'
import { ActionType } from '../../../enum/landing-enum';
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-google-workspace-complete-solutions',
  templateUrl: './google-workspace-complete-solutions.component.html',
  styleUrl: './google-workspace-complete-solutions.component.scss',
})
export class GoogleWorkspaceCompleteSolutionsComponent {
  public mockContent: object[]
  public currentSlide = 1
  public actionTypeEnum = ActionType
  constructor(public translate: TranslateService) {}
  ngOnInit() {
    this.showMockContent()
  }
  goToSlide(slideNo: number) {
    this.currentSlide = slideNo
  }
  showMockContent() {
    const baseUrl = 'https://flowaccountcdn.com/new_landing/image/google-workspace/complete-solutions/'
    const googleWorkspaceBase = 'GOOGLE_WORKSPACE.COMPLETE_SOLUTIONS.'

    this.mockContent = [
      {
        navigation: `${googleWorkspaceBase}1.NAVIGATION`,
        image: `${baseUrl}create.png`,
        imageWebp: `${baseUrl}create.webp`,
        icon: ['Slides', 'Forms', 'Sheets', 'Docs'],
        title: `${googleWorkspaceBase}1.TITLE`,
        detail: `${googleWorkspaceBase}1.DETAIL`,
      },
      {
        navigation: `${googleWorkspaceBase}2.NAVIGATION`,
        image: `${baseUrl}communicate.png`,
        imageWebp: `${baseUrl}communicate.webp`,
        icon: ['Gmail', 'Chat', 'Meet', 'Calendar'],
        title: `${googleWorkspaceBase}2.TITLE`,
        detail: `${googleWorkspaceBase}2.DETAIL`,
      },
      {
        navigation: `${googleWorkspaceBase}3.NAVIGATION`,
        image: `${baseUrl}keep.png`,
        imageWebp: `${baseUrl}keep.webp`,
        icon: ['Drive', 'Keeps'],
        title: `${googleWorkspaceBase}3.TITLE`,
        detail: `${googleWorkspaceBase}3.DETAIL`,
      },
      {
        navigation: `${googleWorkspaceBase}4.NAVIGATION`,
        image: `${baseUrl}safe.png`,
        imageWebp: `${baseUrl}safe.webp`,
        icon: ['Endpoint', 'Admin', 'Vault', 'flowaccount'],
        title: `${googleWorkspaceBase}4.TITLE`,
        detail: `${googleWorkspaceBase}4.DETAIL`,
      },
    ]
  }
  actionClickSlide(actionName: ActionType) {
    const slideListLength = this.mockContent?.length
    if (slideListLength) {
      if (actionName === ActionType.prev) {
        if (this.currentSlide === 1) {
          this.currentSlide = slideListLength
        } else {
          this.currentSlide -= 1
        }
      } else if (actionName === ActionType.next) {
        if (this.currentSlide === slideListLength) {
          this.currentSlide = 1
        } else {
          this.currentSlide += 1
        }
      }
    }
  }
  getImageUrl(iconName: string) {
    const imageName = iconName.toLowerCase()
    return `https://flowaccountcdn.com/new_landing/image/google-workspace/complete-solutions/icon/${imageName}.png`
  }
}
